import { useState } from "react";
import { ZoomIn } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "../ui/dialog";
import { img } from "../../lib/api";

export const Gallery = ({ images = [], alt }) => {
  const [active, setActive] = useState(0);
  const [zoom, setZoom] = useState(false);
  const [origin, setOrigin] = useState("50% 50%");
  const list = images.length ? images : [""];

  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    setOrigin(`${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`);
  };

  return (
    <div className="flex flex-col-reverse gap-4 lg:flex-row">
      <div className="no-scrollbar flex gap-3 overflow-x-auto lg:w-20 lg:flex-col">
        {list.map((src, i) => (
          <button key={i} data-testid={`gallery-thumb-${i}`} onClick={() => setActive(i)}
            className={`aspect-[3/4] w-16 shrink-0 overflow-hidden border transition-colors lg:w-full ${active === i ? "border-ink" : "border-transparent opacity-60 hover:opacity-100"}`}>
            <img src={img(src)} alt="" className="h-full w-full object-cover" />
          </button>
        ))}
      </div>
      <button data-testid="gallery-main-image" onClick={() => setZoom(true)} onMouseMove={onMove}
        className="group relative aspect-[3/4] flex-1 cursor-zoom-in overflow-hidden bg-sand-light">
        <img src={img(list[active])} alt={alt} style={{ transformOrigin: origin }}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.6]" />
        <span className="absolute bottom-4 end-4 grid h-10 w-10 place-items-center rounded-full bg-ivory/85 backdrop-blur"><ZoomIn size={16} strokeWidth={1.4} /></span>
      </button>
      <Dialog open={zoom} onOpenChange={setZoom}>
        <DialogContent data-testid="gallery-zoom-dialog" className="max-h-[95vh] max-w-4xl rounded-none border-0 bg-ivory p-2">
          <DialogTitle className="sr-only">{alt}</DialogTitle>
          <img src={img(list[active])} alt={alt} className="max-h-[90vh] w-full object-contain" />
        </DialogContent>
      </Dialog>
    </div>
  );
};
